export const comments_5519469 = {"data":{"data":[],"links":{}}}